import { forwardRef } from 'react';
import { Input, InputProps } from '@chakra-ui/react';
import { PatternFormat, PatternFormatProps } from 'react-number-format';
import { useController, UseControllerProps } from 'react-hook-form';

export type SsnInputProps = Partial<PatternFormatProps & InputProps>;

export const SsnInput = forwardRef((props: SsnInputProps, ref) => {
    const { format, ...remainigProps } = props;
    return (
        <PatternFormat
            format={format || '###-##-####'}
            customInput={Input as any}
            type="text"
            getInputRef={ref}
            {...remainigProps}
        />
    );
});

export const RhfSsnInput = (
    props: SsnInputProps & UseControllerProps<any, any>
) => {
    const { name, control, defaultValue, rules, shouldUnregister, ...inputProps } = props;

    const controller = useController({
        name,
        control,
        defaultValue,
        rules,
        shouldUnregister,
    });

    return (
        <SsnInput
            {...inputProps}
            name={controller.field.name}
            value={controller.field.value}
            onValueChange={(value) => {
                controller.field.onChange(value.formattedValue);
            }}
            onBlur={controller.field.onBlur}
            ref={controller.field.ref}
        />
    );
};
